module.exports = __webpack_public_path__ + "static/img/guard.16b5d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard.png
// module id = N/Ma
// module chunks = 0